import { restClient } from '../client';


export type CountyByZipInput = {
  hud?: File;
  zip_county?: File;
  uszips?: File;
};


export type CountyByZipOutput = {
  ok: boolean;
};


export const uploadZipCounty = restClient.createRequest<CountyByZipInput, CountyByZipOutput>({
  url: '/api/v1/admin/upload_zip_county',
  method: 'POST',
  formData: true,
});
